import { createFeature, createReducer, on } from '@ngrx/store';
import { MetaData, Retailer } from '@emi/shared/models';
import * as retailerActions from './retailer-actions';
import * as commonActions from '../common-actions';

export interface RetailerState {
    retailers: Retailer[];
    metadata: MetaData | null;
    searchText: string | null;
    loading: boolean;
    failed: boolean;
    error: string;
}

export const retailerFeatureKey = 'retailerFilters';

const initialState: RetailerState = {
    retailers: [],
    metadata: null,
    searchText: null,
    loading: false,
    failed: false,
    error: '',
};

export const retailerFeature = createFeature({
    name: retailerFeatureKey,
    reducer: createReducer(
        initialState,
        on(retailerActions.isLoadingRetailers, (state) => {
            return {
                ...state,
                loading: true,
            };
        }),
        on(retailerActions.getNextPageRetailers, (state) => {
            return {
                ...state,
                loading: true,
            };
        }),
        on(retailerActions.getRetailersSuccess, (state, { retailers, metadata, searchText }) => {
            return {
                ...state,
                retailers,
                metadata,
                searchText,
                loading: false,
                failed: false,
                error: '',
            };
        }),
        on(retailerActions.updateRetailersSelectionSuccess, (state, { retailers, metadata }) => {
            return {
                ...state,
                retailers: [...state.retailers, ...retailers],
                metadata,
                loading: false,
                failed: false,
                error: '',
            };
        }),
        on(retailerActions.getRetailersFailure, (state, { error }) => {
            return {
                ...state,
                loading: false,
                failed: true,
                error: error.message,
            };
        }),
        on(retailerActions.searchRetailers, (state, { searchText }) => {
            return {
                ...state,
                loading: state.searchText !== searchText,
            };
        }),
        on(commonActions.clearFilters, () => {
            return initialState;
        })
    ),
});
